import { useEffect } from 'react';

import { useConferenceStore } from 'store/conference';
import { useCurrentUserStore } from 'store/currentUser';
import { useDebugStore } from 'store/debug';
import { useTimerStore } from 'store/timer';

import { EUnavailableType } from 'components/Pages/UnavailableContent/constants/unavailableType';
import { useUnavailableContent } from 'components/Pages/UnavailableContent/hooks/useUnavailableContent';

/** Редирект по окончании конференции */
export function useRedirectOnConferenceOver() {
    const { disableManageMicrophoneLevel } = useCurrentUserStore();
    const { leaveConference } = useConferenceStore();
    const { availableTime, setAvailableTime } = useTimerStore();
    const { redirectToUnavailableContentPage } = useUnavailableContent();
    const { isDebugMode } = useDebugStore();

    useEffect(() => {
        if (!isDebugMode) {
            const callIsOver = availableTime !== null && availableTime <= 0;

            if (callIsOver) {
                setAvailableTime(null);
                disableManageMicrophoneLevel.current().finally(() => {
                    leaveConference().finally(() => {
                        redirectToUnavailableContentPage(EUnavailableType.IS_OVER);
                    });
                });
            }
        }
    }, [leaveConference, availableTime, redirectToUnavailableContentPage]);
}
